import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization_regional`;

export function findOrganizationRegional(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}
export function findOrganizationRegionalById(id) {
  return axios.get(`${URL}/${id}`);
}
export function createOrganizationRegional(payload) {
  return axios.post(`${URL}/create`, payload);
}
export function updateOrganizationRegional(payload) {
  return axios.put(`${URL}/update`, payload);
}
export function deleteOrganizationRegionalFolder(id) {
  return axios.delete(`${URL}/delete_folder/${id}`);
}
export function findAllOrgRegional() {
  return axios.get(`${URL}`);
}
